<template>
    <b-modal
        id="create-personal-internship"
        modal-class="apprentice-default-modal create-personal-internship"
        ref="create-personal-internship"
        size="lg"
        :title="$t('internship.add_personal_internship')"
        :ok-title="$t('common.add')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="load"
        @ok="save">
        <div class="personal-internship-create">
            <b-alert
                v-if="errorsFound.length > 0"
                variant="danger"
                show>
                {{ $tc('internship.incorrectly_filled_out_fields', errorsFound.length) }}
                <span v-for="field in errorsFound">{{ field }}, </span>
            </b-alert>

            <b-alert
                v-if="contactErrors"
                variant="warning"
                show>
                {{ $t('internship.you_have_to_fill_in_at_least_one_mail_address_or_phone_number') }}
            </b-alert>

            <div class="personal-internship-organization-group">
                <b-form-group
                    class="personal-internship-name"
                    label-for="personal-internship-name-input"
                    :label="$t('common.name')">
                    <template #label> {{ $t('common.name') }} <span class="required">*</span></template>
                    <b-form-input
                        id="personal-internship-name-input"
                        v-model="name"
                        :placeholder="$t('common.name')">
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    class="personal-internship-organization"
                    label-for="personal-internship-organization-input"
                    :label="$t('common.organization')">
                    <template #label> {{ $t('common.organization') }} <span class="required">*</span> </template>
                    <b-form-input
                        id="personal-internship-organization-input"
                        v-model="organization"
                        :placeholder="$t('internship.organization_name')">
                    </b-form-input>
                </b-form-group>
            </div>

            <b-form-group
                class="personal-internship-organization"
                label-for="personal-internship-organization-input"
                label="Naam stagebegeleider">
                <template #label> {{ $t('internship.name_supervisor') }}: <span class="required">*</span></template>
                <b-form-input
                    id="personal-internship-organization-input"
                    v-model="supervisor"
                    :placeholder="$t('internship.name_supervisor')">
                </b-form-input>
            </b-form-group>

            <design-2021-apprentice-address-form-component
                @contactData="updateContactData($event)"
                ref="contact-info">
            </design-2021-apprentice-address-form-component>

            <b-form-group
                class="personal-internship-description"
                label-for="personal-internship-description-input"
                :label="$t('common.description')">
                <template #label> {{ $t('common.description') }} <span class="required">*</span> </template>
                <ckeditor
                    v-model="description"
                    :editor="editor"
                    :config="editorConfig">
                </ckeditor>
            </b-form-group>

            <b-form-group
                class="internship-rejection-letter"
                label-for="internship-motivation-letter-input"
                :label="$t('internship.motivation')">
                <template v-slot:label> {{ $t('internship.motivation') }}<span class="required">*</span> </template>
                <b-form-textarea
                    class="apprentice-textarea"
                    id="internship-motivation-letter"
                    v-model="motivationLetter"
                    :placeholder="$t('internship.i_would_like_to_participate_in_this_internship_because')"
                    rows="3"
                    max-rows="6">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-internships-student-personal-create-modal-component',
    props: ['projectIn'],
    data() {
        return {
            name: '',
            description: '',
            contactData: {},
            organization: '',
            motivationLetter: '',
            supervisor: '',
            editor: ApprenticeEditor,
            editorConfig: {
                placeholder: this.$t('common.description'),
                contentsCss: 'internship-description',
                bodyClass: 'internship-description-body',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            errorsFound: [],
            contactErrors: false,
        };
    },
    methods: {
        save(bvModalEvent) {
            if (this.hasErrors() || this.contactErrors) {
                Vue.nextTick(() => {
                    $('.create-personal-internship').animate({ scrollTop: 0 }, 500);
                });
                bvModalEvent.preventDefault();
                return;
            }

            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('contactData', JSON.stringify(this.contactData));
            formData.append('organization', this.organization);
            formData.append('projectId', this.projectIn.id);
            formData.append('motivationLetter', this.motivationLetter);

            if (this.supervisor !== '') {
                formData.append('supervisor', this.supervisor);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.studentPersonalInternshipCreate(), formData, { headers: headers })
                .then((response) => {
                    this.$emit('signed-internship', response.data);
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },

        load() {
            this.name = '';
            this.location = '';
            this.motivation = '';
            this.description = '';
            this.errorsFound = [];
            this.contactErrors = false;
            this.organization = '';
        },

        updateContactData(contactData) {
            this.contactData = contactData;
        },

        hasErrors() {
            this.errorsFound = [];
            this.contactErrors = false;

            if (this.name === '') {
                this.errorsFound.push(this.$t('common.name'));
            }
            if (this.description === '') {
                this.errorsFound.push(this.$t('common.description'));
            }
            if (this.motivationLetter === '') {
                this.errorsFound.push(this.$t('internship.motivation'));
            }

            if (this.organization === '') {
                this.errorsFound.push(this.$t('common.organization'));
            }

            if (this.contactData.city === undefined || this.contactData.city === '') {
                this.errorsFound.push(this.$t('common.city'));
            }

            if (this.contactData.street === undefined || this.contactData.street === '') {
                this.errorsFound.push(this.$t('common.street'));
            }

            if (this.contactData.streetNumber === undefined || this.contactData.streetNumber === '') {
                this.errorsFound.push('internship.house_number');
            }

            if (this.contactData.zipcode === undefined || this.contactData.zipcode.length !== 6) {
                this.errorsFound.push(this.$t('common.postal_code'));
            }
            if (this.contactData.email !== undefined && this.contactData.email !== '') {
                if (!this.$options.filters.validate_email(this.contactData.email)) {
                    this.errorsFound.push('email');
                }
            }

            if (
                (this.contactData.email === undefined || this.contactData.email === '') &&
                (this.contactData.phone === undefined || this.contactData.phone === '')
            ) {
                this.contactErrors = true;
            }

            return !!this.errorsFound.length;
        },
    },
};
</script>

<style scoped lang="scss">
input.form-control {
    margin-bottom: 0;
}

.personal-internship-organization-group {
    display: flex;
    flex-direction: column;
    column-gap: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .personal-internship-organization-group {
        flex-direction: row;

        .personal-internship-organization {
            flex: 1 0 calc(33% - 15px);
        }

        .personal-internship-name {
            flex: 1 0 calc(67% - 15px);
        }
    }
}
</style>
